import * as React from "react"
import * as Conf from "../../../configuration"
import * as CommonUtils from "../../utils"
import { bodyW } from "../../pptx-configuration/constants"

export default class InvestPrevRealCompareTable extends React.Component<Props> {
	private readonly LABEL_CELL_WIDTH: number
	private readonly VALUE_CELL_WIDTH: number
	private yearHeader:string[];

	constructor(props: Readonly<Props>) {
		super(props)
        this.LABEL_CELL_WIDTH = CommonUtils.toInches(6.3);
		this.VALUE_CELL_WIDTH = (bodyW - this.LABEL_CELL_WIDTH)/4;
		this.yearHeader = [];
		this.buildYearHeader(this.props.currentYear);
		
	}

	buildYearHeader(currentYear:number){
        this.yearHeader.push("BUDGET "+ new Date().getFullYear());
        this.yearHeader.push("CA PROVISOIRE");
	}

	render() {
		const tableConf = this.props.tableConfiguration
		
		return<table id={this.props.id}>
				<thead>
					<tr>
						<th data-pptx-width={this.LABEL_CELL_WIDTH}
						style={{ ...tableConf.header }}></th>

						{this.yearHeader.map((y, yi) =>
							<th data-pptx-width={this.VALUE_CELL_WIDTH}
							key={yi}
							style={{ ...tableConf.header }}>{y}</th>
						)}
					</tr>
				</thead>
				{this.renderExpenseTBody()}	
                {this.renderTotalTBody()}		
			</table>
		
	}

	private getDisplayedValue(value: number, type?: RowType,key?:number): React.ReactText {
		return ""
	}

	private getRowBaseStyle(row: TableRow): React.CSSProperties {
		if (isSubtotalTableRow(row)) return this.props.tableConfiguration.subtotal
		if (isTotalTableRow(row)) return this.props.tableConfiguration.total
		return this.props.tableConfiguration.common
	}

	private renderExpenseTBody(): React.ReactNode {
		const rows: TableRow[] = [];
        
		this.props.expenceTableDatas.forEach(chapter=>{
            if(chapter.chapitreLibelle != ""){
                rows.push({
                    label:chapter.chapitreNumber + " - " + chapter.chapitreLibelle ,
                    values:[]                
                });                
            }
		})
		return <tbody>
			{rows.map(
			(row, rowIndex) =>
				this.props.enableHideZeroLines ?	CommonUtils.isArrayAllValuesZero(row.values) === false && this.renderRow(row, rowIndex) : this.renderRow(row, rowIndex)
			)}
      	</tbody>
	}

    private renderTotalTBody():React.ReactNode{
        const rows: TableRow[] = [];

        rows.push({
            label:"Sous-total" ,
            values:[],       
            subtotal:true       
        });
        if(this.props.isReceipt){
            rows.push({
                label:"Report N-1" ,
                values:[],              
            });
        }else{
            rows.push({
                label:"Résultat prévisionnel année " + this.props.currentYear ,
                values:[],              
            });
        }
        rows.push({
            label:"TOTAL" ,
            values:[],       
            total:true       
        });

        return <tbody>
			{rows.map(
			(row, rowIndex) =>
				this.props.enableHideZeroLines ?	CommonUtils.isArrayAllValuesZero(row.values) === false && this.renderRow(row, rowIndex) : this.renderRow(row, rowIndex)
			)}
      	</tbody>
    }

	private renderRow(row: TableRow, key?: number): React.ReactNode {
		const years = this.props.years

		const conf = this.props.tableConfiguration
		const baseStyle: React.CSSProperties = this.getRowBaseStyle(row)

		return <tr key={key}>
			<td style={{ ...baseStyle }}>{row.label}</td>
			{years.map((_y, yearIndex) => {
				const value = row.values[yearIndex]
				return <td key={yearIndex} style={{ ...baseStyle, ...conf.numeric }}>
					{this.getDisplayedValue(value, row.type,yearIndex)}
				</td>
			})}
		</tr>
	}
}

export interface Props {
	expenceTableDatas:ChapterRow[];
	currentYear:number;
    id: string;
    isReceipt:boolean;
    currency: string;
    locale: string;
    roundness: Conf.RoundnessValue
    enableHideZeroLines: boolean;
	tableConfiguration: Conf.TableConfiguration;
	years: number[];
}

function isSubtotalTableRow(row: TableRow): row is SubtotalTableRow {
	return undefined !== (row as SubtotalTableRow).subtotal
}

function isTotalTableRow(row: TableRow): row is TotalTableRow {
	return undefined !== (row as TotalTableRow).total
}

interface BaseTableRow {
	label: string
	values: number[]
	type?: RowType
}

interface SubtotalTableRow extends BaseTableRow {
	subtotal: boolean
}

interface TotalTableRow extends BaseTableRow {
	total: boolean
}

interface YearHeader{
	year:number;
	isReal:boolean;
	libelle:string;
}

type RowType = "currency" | "duration" | "percentage"

type TableRow = BaseTableRow | SubtotalTableRow | TotalTableRow

export interface ChapterRow{
	chapitreNumber:string;
	chapitreLibelle:string;
	values:number[]
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/observation-generator/comparaison-generator/invest-prev-real-compare-table.tsx